export default __webpack_public_path__ + "static/media/content.41efa02a.png";